module.exports = __webpack_public_path__ + "img/italy-infectious-diseases-male.14f75c7a.png";